<template>
  <div class="ui clearing segment">
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="bed icon"></i>
        <div class="content">
          Patient Information
        </div>
      </h2>
    </div>

    <div class="ui divider"></div>  
    
    <div class="ui form" id="patient-search-step" >
        <div class="field">
          <label for="">Search using mobile phone</label>
          <div class="ui search">
            <div class="ui icon fluid input">

              <input 
                class="prompt" 
                type="text" 
                placeholder="Search patients..." 
                v-model="searchPhoneNumber"
              >
              <i class="search icon"></i>
          </div>
          <div class="results"></div>
        </div>
      </div>
    </div>

    <br/>
    <div class="ui divider"></div>
    <div class="ui form" id="patient-step">
      <div class="required field">
        <label for="name">{{ $t('name') }}</label>
        <div class="ui input" v-if="useInventory">
          <input
            type="text"
            :placeholder="$t('name')"
            v-model="patient.name"
            name="name"
            id="patient-name"
          />
        </div>
        <div v-else>{{patient.name}}</div>
      </div>

      <div 
        class="fields"
        :class="{two: !useInventory, three: useInventory}"
      >
        <div class="required field">
          <label for="cell_phone">{{ $t('mobile') }}</label>
          <div class="ui input left icon" v-if="useInventory">
            <i class="mobile icon"></i>
            <input
              type="text"
              :placeholder="$t('mobile')"
              v-model="patient.cell_phone"
              name="cellPhone"
              id="patient-cellPhone"
            />
          </div>
          <div v-else>{{ patient.cell_phone }}</div>
        </div>

        <div class="field" v-if="useInventory">
          <label for="weight"> {{ $t('weight') }}</label>
          <div class="ui input">
            <input
              type="number"
              :placeholder="$t('weight')"
              v-model="patient.weight"
              name="weight"
            />
          </div>
        </div>
        
        <div class="required field">
          <label for="gender">Gender</label>
          <select
            class="ui fluid search dropdown"
            id="patient-gender-search"
            v-model="patient.gender"
            name="gender"
            v-if="useInventory"
          >
            <option value="">{{ $t('chooseEmployeeGender') }}</option>
            <option :value="1">{{ $t('male') }}</option>
            <option :value="2">{{ $t('female') }}</option>
          </select>
          <div v-else>{{ patient.gender === "1"? 'Male' : patient.gender === "2" ? 'Female' : ''}}</div>
        </div>
      </div>
      <div
        class="ui blue right floated right labeled icon button"
        style="background-color: #092442;"
        :class="{disabled: !isValid}"
        @click="next()"
      >
        <i class="right arrow icon"></i>
        Next
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      patient: {
        name: '',
        critical_diseases: [],
        gender: null,
        weight: null,
        date_of_birth: null,
        cell_phone: null,
        telephone: null
      },
      searchPhoneNumber: null,
      isValid: false
    };
  },
  watch: {
    patient: {
      handler: function () {
        this.isValid = $('#patient-step').form('is valid')
      },
      deep: true
    }
  },
  created() {
    this.initGUI();
  },
  mounted() {
  },
  computed: {
    useInventory() {
      return this.permissions.invetory_permissions.used
    },
  },
  methods: {
    isFormValid () {
      return $('#patient-step').form('is valid')
    },
    initGUI() {
      this.$nextTick(() => {
        $('#patient-gender-search').dropdown();
        $('.ui.search')
          .search({
            minCharacters : 5,
            fields: {
              title   : 'name'
            },
            apiSettings: {
              responseAsync: (settings, callback) => {
                this.$http.get('patients/search-list', {
                  params: {
                    cell_phone: this.searchPhoneNumber,
                    clinic_id: this.getClinicId()
                  }
                }).then(response => {
                  this.patients = response.data.map(patient => ({...patient, name: this.adjustName(patient.name)}))
                  callback({
                    success: true,
                    results: this.patients
                  })
                })
              }
            },
            onSelect: result => {
              this.patient = result
              if (this.useInventory) {
                document.getElementById("patient-name").value = this.adjustName(this.patient.name);
                document.getElementById("patient-cellPhone").value = this.patient.cell_phone;
                $('#patient-gender-search').dropdown('set selected', result.gender)
              }
            }
          })
        
        $('#patient-step').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter patient name.'
                }
              ]
            },
            gender: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose patient gender.'
                },
                {
                  type: 'integer[1..2]',
                  prompt: 'Please choose valid option.'
                }
              ]
            },
            cellPhone: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter patient cell phone.'
                },
                {
                  type: 'integer',
                  prompt: 'Please enter valid cell phone number.'
                },
                {
                  type: 'minLength[11]',
                  prompt: 'Please enter valid cell phone number.'
                }
              ]
            }
          }
        });
      });
    },
    next() {
      this.$emit('reservation-patientStepChanges', {
        data: {
          patient: this.patient,
          next: $('#patient-step').form('is valid')
        }
      });
    }
  }
};
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/reservations/new_reservations_steps/PatientInfoStep.vue